<template>
  <div v-if="loaded">
    <div class="card card-custom gutter-b">
      <div class="card-body">
        <!--begin::Details-->
        <div class="row">
          <div class="col">
            <div class="d-flex justify-content-start">
              <!--begin: Pic-->
              <div class="flex-shrink-0 mr-7 mt-lg-0 mt-3">
                <div class="symbol symbol-50 symbol-lg-120">
                  <img
                    :src="`/media/devices/${adminDevice.type}.png`"
                    alt="image"
                  />
                </div>
                <div
                  class="symbol symbol-50 symbol-lg-120 symbol-primary d-none"
                >
                  <span class="font-size-h3 symbol-label font-weight-boldest">
                    {{ adminDevice.name }}
                  </span>
                </div>
              </div>
              <!--end::Pic-->
              <!--begin::Info-->
              <div class="flex-grow-1">
                <!--begin::Title-->

                <div class="d-flex justify-content-between flex-wrap mt-1">
                  <div class="flex-shrink-0 mr-7 mt-lg-0 mt-3">
                    <div class="d-flex mr-3">
                      <a
                        href="#"
                        class="text-dark-75 text-hover-primary font-size-h5 font-weight-bold mr-3"
                      >
                        {{ adminDevice.name }}
                      </a>
                    </div>
                    <div class="d-flex mr-3">
                      <a href="#" class="text-dark-75 text-hover-primary  mr-3">
                        {{ adminDevice.code }}
                      </a>
                    </div>
                  </div>
                </div>
                <!--end::Title-->
              </div>
              <!--end::Info-->
            </div>
          </div>
          <!--end::Details-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_ADMIN_DEVICE,
  DESTROY_ADMIN_DEVICE
} from "@/core/services/store/admin/devices.module";

import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "adminDevicesShow",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_ACTIONS, {
      buttons: [
        {
          name: '<i class="flaticon2-trash"></i>حذف',
          event: "delete-device-event",
          class: "btn-danger"
        }
      ],
      links: [
        {
          name: '<i class="flaticon-edit"></i>ویرایش',
          to: {
            name: "admin-devices-edit",
            params: { id: this.$route.params.id }
          },
          class: "btn-primary"
        }
      ]
    });

    this.eventHub.$on("delete-device-event", this.destroy);

    this.getDevice();
  },
  computed: {
    ...mapGetters(["adminDevice"])
  },
  methods: {
    getDevice() {
      let deviceId = this.$route.params.id;
      this.loaded = false;

      this.$store
        .dispatch(FETCH_ADMIN_DEVICE, deviceId)
        .then(() => {
          this.loaded = true;

          this.$store.dispatch(SET_BREADCRUMB, [
            {
              title: "مدیریت",
              route: { name: "admin-dashboard" }
            },
            { title: "دستگاه ها", route: { name: "admin-devices-index" } },
            { title: this.adminDevice.name }
          ]);
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    destroy() {
      let id = this.$route.params.id;

      Swal.fire({
        title: "",
        text: "آیا از حذف دستگاه اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_ADMIN_DEVICE, id).then(() => {
            this.eventHub.$emit("re_render_page", this);
          });
        }
      });
    }
  }
};
</script>
